
import {
  computed, defineComponent, PropType,
} from 'vue';
import InputNumber from 'primevue/inputnumber';

export default defineComponent({
  name: 'AmountStepper',

  components: { InputNumber },

  props: {
    modelValue: {
      type: Number as PropType<number>,
      required: true,
    },
    /** Predefined step values, e.g. [10, 25, 50, 100, 200, 500]. +/- jumps to the next/previous in this list. */
    steps: {
      type: Array as PropType<number[]>,
      required: true,
    },
    suffix: {
      type: String,
      default: '€',
    },
    label: {
      type: String,
      default: '',
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 100000,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    incrementLabel: {
      type: String,
      default: 'Increase amount',
    },
    decrementLabel: {
      type: String,
      default: 'Decrease amount',
    },
  },

  emits: ['update:modelValue'],

  setup(props, { emit }) {
    const canStepUp = computed(() => (
      props.modelValue < props.steps[props.steps.length - 1]
    ));
    const canStepDown = computed(() => props.modelValue > 0);

    const stepUp = () => {
      const next = props.steps.find((s) => s > props.modelValue);
      if (next != null) emit('update:modelValue', next);
    };

    const stepDown = () => {
      const prev = [...props.steps].reverse().find((s) => s < props.modelValue);
      emit('update:modelValue', prev ?? 0);
    };

    const onChange = (v: number | null | undefined) => {
      const value = v == null || v < 0 ? 0 : Number(v);
      emit('update:modelValue', value);
    };

    return {
      canStepUp,
      canStepDown,
      stepUp,
      stepDown,
      onChange,
    };
  },
});
